import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'rdf-block-controls',
  templateUrl: './block-controls.component.html',
  styleUrls: ['./block-controls.component.css']
})
export class BlockControlsComponent implements OnInit {
  @Input() block;
  @Input() blockNumberArray;
  @Input() blockPosition
  @Input() formEditorConfiguration  = 'default'
  @Output() onDeleteBlock = new EventEmitter()
  @Output() onRenameBlock = new EventEmitter()
  @Output() onMoveBlock = new EventEmitter()
  @Output() onSetBlockType = new EventEmitter()
  @Output() onSetSumTotals = new EventEmitter()

  constructor() { }

  ngOnInit() {
  }

  deleteBlock() {
    this.onDeleteBlock.emit()
  }

  moveBlock(val) {
    this.onMoveBlock.emit(val)
  }

  setSumTotals(sumTotals){
    this.onSetSumTotals.emit(sumTotals)
  }

  setBlockType(blockType){
    this.onSetBlockType.emit(blockType)
  }

  isTableable(){
    return !this.block.rows || this.block.rows.length === 0
  }
}
